<template>
  <div class="alltypeSelect">
    <el-select style="width: 100%;" v-model="localValue" filterable clearable :placeholder="`请选择${txt}`"
      @change="handleSelectChange">
      <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { getdlrlistApi } from '@/Api/agentapi';
import { allbqAPI, getotherlabelAPI, gethangyelistAPI, getarealistAPI } from '@/Api/alltypesele';
import { getcustomerlistApi } from '@/Api/kfserveagl';
import { getPriceTypeApi } from '@/Api/home';


export default {
  name: 'alltypeSelect',
  props: {
    type: {
      type: Number,
      default: 1
    },
    txt: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
    }
  },
  data() {
    return {
      list: [],
      localValue: this.value
    }
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    localValue(newVal) {
      this.$emit('changeSelect', newVal);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {

    async fetchData() {
      const typeToApiMap = {
        0: this.getcustomerlist, //企业
        1: this.getdlrlist,//地理人
        2: this.getarealist,//省市县
        3: this.gethangyelist,//行业类别
        4: this.getOtherLabel.bind(this, 'diantype'), // 电压分类
        5: this.getOtherLabel.bind(this, 'voltage'),  // 用电分类
        6: this.getQbbqList.bind(this, 'guimo'),      // 用电规模分类
        7: this.getQbbqList.bind(this, 'sctype'),     // 生产分类
        8: this.getQbbqList.bind(this, 'tezheng'),    // 用电特征分类
        9: this.getQbbqList.bind(this, 'hetong'),     // 合同期限分类
        10: this.getQbbqList.bind(this, 'taocan'),    // 套餐类型
        11: this.getQbbqList.bind(this, 'piancha'),    // 偏差特点
        12: this.getPriceType //及格类型
      };

      const fetchFunction = typeToApiMap[this.type];
      if (fetchFunction) {
        await fetchFunction();
      }
    },
    // 获取价格类型
    async getPriceType() {
      let res = await getPriceTypeApi()
      if (res.code === 0 && res.data?.length > 0) {
        this.list = res.data.map(item => ({
          label: item.name,
          value: item.id
        }));
      } else {
        this.list = [];
      }
    },
    async getQbbqList(category) {
      const res = await allbqAPI();
      if (res.code === 0 && res.data[category]?.length > 0) {
        this.list = res.data[category].map(item => ({
          label: item.name,
          value: item.id
        }));
      } else {
        this.list = [];
      }
    },
    async getOtherLabel(category) {
      const res = await getotherlabelAPI();
      if (res.code === 0) {
        if (category === 'voltage') {
          this.list = Object.entries(res.data[category]).map(([key, value]) => ({
            label: value,
            value: parseInt(key, 10)
          }));
        } else if (res.data[category]?.length > 0) {
          this.list = res.data[category].map(item => ({
            label: item.name,
            value: item.id
          }));
        } else {
          this.list = [];
        }
      }
    },
    async getdlrlist() {
      const res = await getdlrlistApi();
      if (res.code === 0 && res.data.data?.length > 0) {
        this.list = res.data.data.map(item => ({
          label: item.realname,
          value: item.id
        }));
      } else {
        this.list = [];
      }
    },
    async getcustomerlist() {
      const res = await getcustomerlistApi();
      if (res.code === 0 && res.data.data?.length > 0) {
        this.list = res.data.data.map(item => ({
          label: item.company,
          value: item.id
        }));
      } else {
        this.list = [];
      }
    },
    async getarealist() {
      const res = await getarealistAPI();
      if (res.code === 0) {
        this.list = res.data.flatMap(item =>
          item.children.map(element => ({
            label: element.text,
            value: element.value
          }))
        );
      } else {
        this.list = [];
      }
    },
    async gethangyelist() {
      const res = await gethangyelistAPI();
      if (res.code === 0 && res.data?.length > 0) {
        this.list = res.data.map(item => ({
          label: item.name,
          value: item.id
        }));
      } else {
        this.list = [];
      }
    },
    handleSelectChange(val) {
      this.$emit('changeSelect', val);
    }
  }
}
</script>

<style lang="scss" scoped></style>